import { IonButton, IonInput, IonItem } from '@ionic/react';
import React from 'react';
import { FieldError, NormalText, Spacer, Title } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import { withTranslation } from '../../lib/translate';
import { getLocale, validateForm } from '../../lib/utils';
import { loading, sendRefer } from '../../store/actions';
import './index.css';
import { getConfig } from '../../appConfig';
import FieldWrapper from '../../components/fieldWrapper';
import { connect } from 'react-redux';

class ReferAFriend extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			formErrors: {},
			referpoint: 10,
			referCodeCopied: false
		};
		this.formConfig = {
			email: { type: 'email', required: true },
		};
	}

	getReferingPoint = async () => {
		this.props.dispatch(loading(true));
		const config = await api.getFrontEndAppConfig();
		this.setState((state) => ({
			...state,
			referpoint: config.front_end_app_config.api_config.refer_a_friend_stamp_power,
		}));
		this.props.dispatch(loading(false));
	};

	componentDidMount() {
		this.getReferingPoint();
	}

	handleInput(key, val) {
		this.setState({ [key]: val });
	}

	handleRefer = () => {
		const { dispatch, __ } = this.props;
		let formErrors = validateForm(this.formConfig, this.state, __);
		this.setState({ formErrors });
		if (Object.keys(formErrors).length === 0) {
			const { email } = this.state;
			const data = { email: email };
			this.setState({ email: '' });
			dispatch(sendRefer(data));
		}
	};

	render() {
		const { __, profile } = this.props;
		const { email } = this.state;
		let referText = `${__('Once your friend has signed up and used the app you will both receive a reward of')} ${this.state.referpoint} ${__('points')}`
		if (getConfig().general.referText) {
			if (typeof getConfig().general.referText == 'string') {
				referText = `${__(`${getConfig().general.referText}`)}`
			} else {
				referText = getConfig().general.referText[getLocale(this.props.profile)]

			}
		}
		return (
			<Loading transparent>
				<Layout showHamburger color="transparent" headerTitle={__('Refer A Friend')}>
					<div className="absolute-content" >
						{getConfig().flags.hasReferCode ? <>
							<Title>{__('Refer A Friend')}</Title>
							<Spacer size={2} />

							<div className='refer-a-friend-point'>
								<div>1</div>
								<NormalText>{__('Once your friend has signed up and used the app you will both receive a reward of 10 points!')}</NormalText>
							</div>
							<Spacer size={4} />
							<div className='refer-a-friend-point'>
								<div>2</div>
								<NormalText>{__('Ask your friend to use the referral code above when they register to the 5Loyalty app and once they complete a transcation in app or in store, you will receive your reward in your account.')}</NormalText>
							</div>
							<Spacer size={4} />
							{profile.referrer_code &&
								<IonButton onClick={() => {
									this.setState({ referCodeCopied: true }, () => {
										navigator.clipboard.writeText(profile.referrer_code)
									})
								}}
									color='primary' fill='outline' expand='block'>{this.state.referCodeCopied ? __('Code copied!') : profile.referrer_code}</IonButton>

							}
						</> :
							<>

								<Title>{__('Refer A Friend')}</Title>
								<NormalText>
									{referText}
								</NormalText>
								<Spacer size={5} />
								<FieldWrapper error={__(this.state.formErrors.email)}>
									<IonInput
										onIonInput={(e) => this.handleInput('email', e.target.value)}
										required
										placeholder={__("Friend's email address")}
										type="email"
										pattern="email"
										inputmode="email"
										value={email}
									/>

								</FieldWrapper>

								<Spacer size={5} />
								<IonButton expand="block" color="primary" strong={true} onClick={() => this.handleRefer()}>
									{__('Send Invitation')}
								</IonButton>
							</>}
					</div>
				</Layout>
			</Loading>
		);
	}
}
const stateToProps = (state) => {
	return {
		profile: state.profile.profile || null,
	};
};
export default connect(stateToProps)(withTranslation(ReferAFriend));
